module.exports = __webpack_public_path__ + "static/media/sadia.8c1be2c3.png";